import Cookies from '../vendor/js.cookie.js'

setTimeout(function() {
    if (!Cookies.get('infoHide') && $('#modalInfo .gform_wrapper').length) {
        $('#modalInfo').modal('show');
    }
}, 20000);

// Rest for success message
$('#modalInfo .modal-close').on('click', function() {
    if (!Cookies.get('infoHide')) {
        Cookies.set('infoHide', 'true', { expires: 1460 });
    }
});

$(document).on("gform_confirmation_loaded", function(e, form_id) {
    if (form_id == 1) {
        Cookies.set('infoHide', 'true', { expires: 1460 });
    }
});